type ClientConfigResponse = {
  status: "success" | "error";
  data?: {
    auth?: {
      google?: boolean;
    };
  };
};

export type ClientConfig = {
  auth: {
    google: boolean;
  };
};

const FALLBACK_CLIENT_CONFIG: ClientConfig = {
  auth: {
    google: false,
  },
};

let clientConfigPromise: Promise<ClientConfig> | null = null;

export function getClientConfig(): Promise<ClientConfig> {
  if (typeof window === "undefined") return Promise.resolve(FALLBACK_CLIENT_CONFIG);

  clientConfigPromise ??= fetch("/api/client-config", { credentials: "same-origin" })
    .then(async (response) => {
      if (!response.ok) return FALLBACK_CLIENT_CONFIG;
      const body = (await response.json()) as ClientConfigResponse;
      return {
        auth: {
          google: Boolean(body.data?.auth?.google),
        },
      };
    })
    .catch(() => FALLBACK_CLIENT_CONFIG);

  return clientConfigPromise;
}
